<template>
  <div>
    <form @submit.prevent>
      <div id="tim-kiem-thong-tin" class="box-form">
        <b-form-group
          label=""
          label-for="keyword"
          class="border-bottom-form d-none"
        >
          <div class="d-flex">
            <div class="flex-1-0">
              <b-form-input
                v-model="requestInformation.filterBy"
                id="filterBy"
                type="text"
                required
                placeholder="Nhập tên vai trò, tên hiển thị"
                @keyup.enter="timDanhSachVaiTro"
              />
            </div>
            <div class="ml-2">
              <base-button button="Tìm kiếm" @click="timDanhSachVaiTro()" />
            </div>
          </div>
        </b-form-group>
        <div class="box-form-result">
          <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
          <DataTable
            :value="danhSachVaiTroNoiBo"
            :loading="isLoadingTable"
            :selection.sync="selectedVaiTro"
          >
            <Column
              field="id"
              headerStyle="width: 40px"
              header=""
              bodyStyle="text-align: center"
              selectionMode="multiple"
            >
            </Column>
            <Column
              field="stt"
              dataKey="stt"
              headerStyle="width: 40px"
              headerClass="p-2"
              header="STT"
              bodyStyle="text-align: center"
            >
              <template #filter> </template>
              <template #body="slotProps">
                <span>{{
                  (requestInformation.pageIndex - 1) *
                    requestInformation.pageSize +
                  slotProps.index +
                  1
                }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="name"
              header="Tên vai trò"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.Name"
                  @change="layDanhSachVaiTro"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.name }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="displayName"
              header="Tên hiển thị"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.DisplayName"
                  @change="layDanhSachVaiTro"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.displayName }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="appName"
              header="Ứng dụng"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.AppName"
                  @change="layDanhSachVaiTro"
                />
              </template>
              <template #body="slotProps">
                <div v-html="slotProps.data.appName"></div>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="thaoTac"
              header="Thao tác"
              headerStyle="width: 100px"
            >
              <template #body="slotProps">
                <div class="text-center">
                  <b-icon
                    icon="plus-circle-fill"
                    variant="success"
                    v-b-popover.hover.top="'Thêm vai trò vào người dùng'"
                    class="cursor-pointer color-red ml-2"
                    @click="themVaiTro(slotProps.data.id)"
                  ></b-icon>
                </div>
              </template>
            </Column>
            <template #empty
              ><div class="text-center">Không có dữ liệu</div></template
            >
            <template #loading
              ><div class="text-center">Đang tải dữ liệu ...</div>
            </template>
          </DataTable>
          <BasePagination
            class="mt-3"
            :current-page="requestInformation.pageIndex"
            :total-pages="totalPages"
            :total-rows="totalRows"
            @changeNum="onChangeNum($event)"
            @changePages="onChangePages($event)"
          />
        </div>
        <div class="box-form-result footer d-flex justify-content-end mt-3">
          <base-button
            :disabled="danhSachIdVaiTroDaChon.length === 0"
            class="btn search-information-btn d-block mr-2"
            @click="themDanhSachVaiTroDaChon()"
            button="Thêm mới"
          >
            Thêm vai trò đã chọn
          </base-button>
          <base-button button="Đóng" @click="hideModal"></base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import {
  ROUTE_NAME,
  MENU_ROUTE_NAME,
  BANG_VAI_TRO,
  BO_QUA_BUTTON_LABEL,
} from "@/constants/constants";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import { THEM_VAI_TRO_VAO_NGUOI_DUNG_THANH_CONG } from "@/constants/message";

export default {
  name: "DanhSachVaiTroKhongThuocNguoiDung",
  components: {
    BasePagination,
  },
  data() {
    return {
      MENU_ROUTE_NAME: `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}`,
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      requestInformation: {
        pageSize: 10,
        pageIndex: 1,
        filterBy: "",
      },
      requestForm: {},
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      deletedId: null,
      nguoiDungId: null,
      danhSachIdVaiTroDaChon: [],
      danhSachIdVaiTro: [],
      selectAllRowsInPage: false,
      emptyHeaderTable: [
        BANG_VAI_TRO.stt,
        BANG_VAI_TRO.name,
        BANG_VAI_TRO.displayName,
        BANG_VAI_TRO.appName,
        BANG_VAI_TRO.thaoTac,
      ],
      selectedVaiTro: [],
    };
  },
  created() {
    this.layDanhSachVaiTro();
  },
  computed: {
    ...mapGetters({
      danhSachVaiTro: "user/danhSachVaiTroKhongThuocNguoiDung",
    }),
    danhSachVaiTroNoiBo() {
      return this.layDanhSachVaiTroNoiBo(this.danhSachVaiTro);
    },
    fieldName() {
      return this.getFieldName();
    },
    hasPageData() {
      return !_isEmpty(this.danhSachVaiTro);
    },
    danhSachVaiTroDaChon: {
      get: function () {
        let danhSachVaiTro = this.danhSachVaiTroNoiBo.filter((quyen) =>
          this.danhSachIdVaiTroDaChon.includes(quyen.Id)
        );

        return danhSachVaiTro.items.map((quyenDaChon, index) => {
          return Object.assign({}, quyenDaChon, {}, { stt: index + 1 });
        });
      },
      set: function () {},
    },
  },
  props: {
    chiTietNguoiDung: {
      type: Object,
      required: true,
    },
    appId: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  watch: {
    selectedVaiTro: {
      handler() {
        this.danhSachIdVaiTroDaChon = (this.selectedVaiTro || []).map(
          (x) => x.id
        );
      },
      deep: true,
    },
    danhSachVaiTro: {
      handler() {
        this.danhSachIdVaiTro = this.layDanhSachIdVaiTro(
          this.danhSachVaiTroNoiBo
        );
        this.clickSelectAllRowInPage();
        this.totalPages = this.danhSachVaiTro.totalPage;
        this.totalRows = _isNil(this.danhSachVaiTro.totalCount)
          ? 0
          : this.danhSachVaiTro.totalCount;
      },
    },
    selectAllRowsInPage: {
      handler() {
        this.clickSelectAllRowInPage();
      },
    },
  },

  methods: {
    hideModal() {
      this.$bvModal.hide("them-vai-tro-nguoi-dung-modal");
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachVaiTro();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachVaiTro();
    },
    timDanhSachVaiTro() {
      this.layDanhSachVaiTro();
    },
    themVaiTro(id) {
      this.roleIds = [id];
      this.themVaiTroTheoNguoiDung();
    },
    themDanhSachVaiTroDaChon() {
      this.roleIds = this.danhSachIdVaiTroDaChon;
      this.themVaiTroTheoNguoiDung();
    },
    themVaiTroTheoNguoiDung() {
      const $vm = this;
      let payload = {
        userCanBoDepartmentId: this.chiTietNguoiDung.userCanBoDepartmentId,
        userId: this.chiTietNguoiDung.id,
        roleIds: this.roleIds,
        permissionIds: [],
        groupIds: [],
      };
      this.$store
        .dispatch("user/addMapping", payload)
        .then(() => {
          $vm.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: THEM_VAI_TRO_VAO_NGUOI_DUNG_THANH_CONG,
          });
          $vm.$emit("themVaiTroVaoNguoiDungThanhCong");
        })
        .catch((error) => {
          $vm.$toasted.clear();
          if (
            !_isEmpty(error.response) &&
            error.response.data.Errors.length > 0
          ) {
            $vm.$toasted.global.showErrorMessage({
              message: error.response.data.Errors[0].Description,
            });
          }
        });
    },
    layDanhSachIdVaiTro(danhSachVaiTro) {
      if (_isEmpty(danhSachVaiTro.items)) {
        return [];
      }
      return danhSachVaiTro.items.map((item) => item.id);
    },
    clickSelectAllRowInPage() {
      if (this.selectAllRowsInPage) {
        this.$set(
          this,
          "danhSachIdVaiTroDaChon",
          this.danhSachIdVaiTroDaChon.concat(this.danhSachIdVaiTro)
        );
        this.$set(this, "danhSachIdVaiTroDaChon", [
          ...new Set(this.danhSachIdVaiTroDaChon),
        ]);
      } else {
        this.danhSachIdVaiTroDaChon = this.danhSachIdVaiTroDaChon.filter(
          (id) => !this.danhSachIdVaiTro.includes(id)
        );
      }
    },
    layDanhSachVaiTro() {
      const payload = {
        userCanBoDepartmentId: this.chiTietNguoiDung.userCanBoDepartmentId,
        userId: this.chiTietNguoiDung.id,
        appId: this.appId,
        ...this.requestInformation,
        ...this.requestForm,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("user/layDanhSachVaiTroKhongThuocNguoiDung", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    layDanhSachVaiTroNoiBo(danhSachVaiTro) {
      if (_isEmpty(danhSachVaiTro)) {
        return [];
      }
      return danhSachVaiTro.items.map((item, index) => {
        return {
          checkbox: null,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          name: _isNil(item.name) ? "" : item.name,
          displayName: _isNil(item.displayName) ? "" : item.displayName,
          appName: _isNil(item.appName) ? "" : item.appName,
          id: item.id,
          thaoTac: null,
        };
      });
    },
    getFieldName() {
      if (_isEmpty(this.danhSachVaiTroNoiBo)) {
        return [];
      }
      return Object.keys(this.danhSachVaiTroNoiBo[0])
        .filter((key) => key !== "id")
        .map((key) => {
          return {
            key: key,
            label: BANG_VAI_TRO[key],
            tdClass: ["stt"].includes(key) ? "center" : "",
          };
        });
    },
  },
};
</script>


